import React, { Fragment, useEffect, useState } from "react";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";

// redux toolkit
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { payApproveAgreement } from "../../slices/apps/agreementSlice";

// data dosyaları
import Question from "../../assets/images/question.png";

const AgreementPayApproveModal = ({ id, isOpen, toggle }) => {
  const dispatch = useDispatch();

  // states
  const { payApproveAgreementLoading } = useSelector((state) => {
    return {
      payApproveAgreementLoading: state.agreement.payApproveAgreementLoading,
    };
  }, shallowEqual);

  const setPayApprove = async () => {
    const data = {
      agreementId: id,
      isPaid: true,
    };

    try {
      const resultAction = await dispatch(payApproveAgreement(data));

      if (resultAction.meta.requestStatus === "fulfilled") {
        toggle();
      }
    } catch (error) {
      console.error("Failed:", error);
    }
  };

  return (
    <Fragment>
      <Modal size="md" isOpen={isOpen} toggle={toggle} centered>
        <ModalHeader
          className="modal-title "
          id="myLargeModalLabel"
          toggle={toggle}
        >
          Ödeme Onayla
        </ModalHeader>

        <ModalBody className="text-center text-dark">
          <img
            src={Question}
            alt="SMS Question"
            id="candidate-img"
            className="img-fluid mb-4"
            style={{ height: "80px" }}
          />
          <h4 className="text-dark">
            Bu sözleşmeyi ödendi olarak işaretlemek istediğinize emin misiniz?
          </h4>
          <div className="d-flex align-items-center gap-3 mt-5 justify-content-center">
            <Button
              className="btn btn-sm"
              color="primary"
              disabled={payApproveAgreementLoading}
              onClick={setPayApprove}
            >
              Onayla
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </Fragment>
  );
};

export default AgreementPayApproveModal;
